import { OutboundCasesTO } from "../dispatchingAndInvoicing/dispatch-and-invoice-response.model";

export class PackingSaveRequest {
    workOrderItemDetailUidK: number;
    bkWorkOrderItemUidD: number;
    statusUidD: number;
    partSubDivisionUidD: number;
    warehouseUidD: number;
    partQ: number;
    outboundBatchControlUidD: number;
    pickingLabelR: number;
	outboundCaseUidD: number
    outboundCases: OutboundCasesTO;

	constructor() {
		this.outboundCases = new OutboundCasesTO();
	}
}
